import * as React from "react";

import { makeStyles, Typography } from "@material-ui/core";

import { useTranslation } from "client/hooks";
import { Merchant } from "client/lib/apt-merchant";
import { BankFieldSetNames } from "client/lib/apt-merchant/src/fieldsets";

const useStyles = makeStyles(() => ({
  headerText: {
    fontSize: "14px",
  },
}));

export const ConnectorHeading: React.FC<{
  fieldSetName: BankFieldSetNames;
  merchant: Merchant;
}> = ({ fieldSetName, merchant }) => {
  const t = useTranslation();
  const classes = useStyles();

  if (merchant.companyInformation.registeredCountry.value === "United States") {
    const headerString =
      fieldSetName === "PrimaryBankFieldSet"
        ? t("uiManualBankInfoAccordianUsPrimaryBankHeader")
        : t("uiManualBankInfoAccordianSecondaryBankHeader");

    return (
      <Typography className={classes.headerText}>{headerString}</Typography>
    );
  }

  return (
    <Typography variant="h6">
      <strong>{t("uiLinkYourBankHeading")}</strong>
    </Typography>
  );
};
